import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useNavigate } from 'react-router-dom';
import LoginView from 'src/views/auth/LoginView/LoginView';
import DashboardViews from 'src/views';
import UserType from 'src/utils/constants/auth';
import AssignPasswordView from 'src/views/auth/AssignPasswordView/AssignPasswordView';
import PrivateRoute from 'src/components/PrivateRotes/PrivateRoute';
import UserVerificationView from 'src/views/auth/UserVerificationView/UserVerificationView';
import RecoverPasswordView from 'src/views/auth/RecoverPasswordView/RecoverPasswordView';
import RecoverPasswordConfirmationView from 'src/views/auth/RecoverPasswordConfirmationView/RecoverPasswordConfirmationView';
import BureauFormView from 'src/views/publicViews/BureauFormView';
import AvalBuroFormView from 'src/views/publicViews/AvalBuroFormView/AvalBuroFormView';
import OpenPayCardFormView from 'src/views/publicViews/OpenPayCardFormView';
import CardFormSuccessView from 'src/views/publicViews/CardFormSuccessView';
import { setNavigate } from 'src/utils/navigate';

const NavigateSetter = () => {
  const nav = useNavigate();
  useEffect(() => {
    setNavigate(nav);
  }, [nav]);
  return null;
};

const AppRoutes = () => (
  <BrowserRouter>
    <NavigateSetter />
    <Routes>
      <Route path="/admin/login" element={<LoginView userType={UserType.ADMIN} />} />
      <Route path="/buro-validation-form/:token" element={<BureauFormView />} />
      <Route path="/aval-buro-form/:avalToken" element={<AvalBuroFormView />} />
      <Route path="/add-card/:token" element={<OpenPayCardFormView />} />
      <Route path="/add-card-success" element={<CardFormSuccessView />} />
      <Route path="/assign-password" element={<AssignPasswordView />} />
      <Route path="/user/forgot-password" element={<RecoverPasswordView />} />
      <Route path="/admin/forgot-password" element={<RecoverPasswordView />} />
      <Route path="/user/verification" element={<UserVerificationView />} />
      <Route path="/admin/verification" element={<UserVerificationView />} />
      <Route path="/user/recover-password" element={<RecoverPasswordConfirmationView />} />
      <Route path="/admin/recover-password" element={<RecoverPasswordConfirmationView />} />
      <Route path="/*" element={<PrivateRoute component={DashboardViews} />} />
    </Routes>
  </BrowserRouter>
);

export default AppRoutes;
